// Auth credentials (access code + token) sourced directly from hive-auth.
//
// These are an authentication concern, NOT patient-profile data, so they are
// decoupled from `usePatient()` (which only resolves once the patient profile
// is fetched). Reading them here makes them available the moment the user is
// authenticated — including for profile-less users (e.g. on `/care`) and before
// the profile fetch resolves on every other page.
//
// The native auto-login cookie is kept as a fallback for WebView contexts.
import { useAuth } from "@noom/hive-auth";

import { readInAppLoginCookie } from "./useInAppLogin";

export type AuthCredentials = {
  accessCode: string | undefined;
  accessToken: string | undefined;
};

export const useAuthCredentials = (): AuthCredentials => {
  const { user } = useAuth();

  if (user) {
    return { accessCode: user.accessCode, accessToken: user.accessToken };
  }

  const inAppLogin = readInAppLoginCookie();
  return {
    accessCode: inAppLogin?.accessCode,
    accessToken: inAppLogin?.accessToken,
  };
};
